<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">

      <Row :gutter="16" type="flex" style="margin-left: 100px" class-name="info-block">

          <Col span="24">
            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">耳标编号</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.tag_sn}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">来源</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.source_msg}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">性别</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.gender_msg}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">类别</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.cattle_type_name}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">品种</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.cattle_variety_name}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">父系耳标</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.male_tag_sn}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">母系耳标</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.female_tag_sn}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">出生日期</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.birth}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">入圈体重</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.weight}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">胎次</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.num}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">健康状态</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.health}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">所属圈舍</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.cattle_house_name}}</Col>
            </Row>
            <Divider class="ivu-mt ivu-mb" style="background: #fff"/>

            <Row :gutter="16" type="flex" justify="end" class-name="info-row">
              <Col span="5" class-name="info-title">备注</Col>
              <Col span="1">:</Col>
              <Col span="18" class-name="info-content">{{infoData.remark}}</Col>
            </Row>

          </Col>

      </Row>
    </card>

  </div>
</template>
<style>

.info-block {
  background-color: #f4f4f4;
  border-radius: 20px;
  width: 50%;
}

.info-row {
  margin: 10px 0;
}

.info-title {
  text-align: end;
}

.info-content {

}

</style>
<script>
import { cattleInfoDetailApi } from '@/api/cattleFarm/cattleInfo'

export default {
  name: 'cattleInfoInfo',
  data() {
    return {
      infoData: {
        tag_sn: '',
        source_msg: '',
        gender_msg: '',
        cattle_type_name: '',
        cattle_variety_name: '',
        male_tag_sn: '',
        female_tag_sn: '',
        birth: '',
        weight: '',
        num: '',
        health: '',
        cattle_house_name: '',
        remark: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {
    // 加载数据
    loadInfoData(id) {
      cattleInfoDetailApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
